import React, { useEffect } from "react";
import { Link, Outlet } from "react-router-dom";
import styles from "./UserDashBoard.module.scss"
import { BiUserCircle } from 'react-icons/bi';
import { FaWpforms } from 'react-icons/fa';
import { HiDocument } from 'react-icons/hi';
const UserDashBoard = () => {
  useEffect(() => {
    document.title = "Briding 365 | User";
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.userDashBoard}>
      <div className={styles.left}>
        <ul>
          <li> <Link to="/user/profile"><BiUserCircle className={styles.icon} /> Profile</Link> </li>
          <li> <Link to="/user/forms"><HiDocument className={styles.icon} /> Forms</Link> </li>
          <li> <Link to="/user/documents"><FaWpforms className={styles.icon} /> Documents</Link> </li>
        </ul>
      </div>
      <div className={styles.right}>
        <Outlet />
      </div>
    </div>
  );
};
export default UserDashBoard;
